import React from "react";
import ThemeFactory from "../Shared/Theme/ThemeFactory";
import SafetyLoader from "../Safety/Components/SafetyLoader";

export default function Safety() {
    return <SafetyLoader
        title="Bezpieczna turystyka"
        subtitle="Rozwiąż zagadki i poznaj najważniejsze zasady bezpiecznego zachowania w górach i nad wodą. Zdobądź dyplom."
        theme={ThemeFactory.withDirectory("safety")}
    />
}